import React from 'react';
import {BASE, UPLOAD_FILE} from "../../api/Api";
import axios from 'axios';
import LoadingButton from "./LoadingButton";
import {get} from "../../utils/helpers";
import {ProgressBar} from "react-bootstrap";
import Icon from '@mdi/react'
import {makeStyles} from "@material-ui/core/styles";
import { mdiFile, mdiFilePdf, mdiFileWord, mdiFileImage } from '@mdi/js';
import {useTheme} from "@material-ui/core";
import clsx from "clsx";
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        // borderWidth: 3,
        padding: theme.spacing(1,0),
        margin: theme.spacing(1,0),
        borderRadius: 9,
        // borderStyle: 'solid',
        // borderColor: theme.palette.primary.main,
        position: 'relative'
    },
}));

export function MimeTypeIcon({type}){

    let component = mdiFile;

    const {palette} = useTheme()

    switch (type) {
        case 'application/pdf':
            component = mdiFilePdf;
            break;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            component = mdiFileWord;
            break;
        case 'image/png':
            component = mdiFileImage;
            break;
        case 'image/jpeg':
            component = mdiFileImage;
            break;
    }

    return (

        <Icon path={component}
              title="User Profile"
              size={2.5}
        />
    )

}

export default function FileUploader(props){

    const classes = useStyles()

    const file = props.file;

    console.log(file)

    const [isUploading,setIsUploading] = React.useState();


    const [uploadedResponse,setUploadedResponse] = React.useState();

    const [uploadPercentage,setUploadPercentage] = React.useState(0);
    const [uploadError,setUploadError] = React.useState();

    const cancelToken = React.useRef(undefined);

    function onUploadProgress(progressEvent){

        const percentage = (progressEvent.loaded/progressEvent.total) * 100;

        setUploadPercentage(percentage);

    }

    function cancelUpload(){
        if(cancelToken.current)
            cancelToken.current('Opération annulé');

        cancelToken.current = undefined;
        setUploadPercentage();
        setIsUploading(false);

    }

    async function uploadFile(){

        setUploadError()

        const formData = new FormData();

        formData.append('file',file);

        try {

            setIsUploading(true);

            const response = await axios.post(
                UPLOAD_FILE,
                formData,
                {

                    onUploadProgress: (progressEvent)=>{

                        onUploadProgress(progressEvent);

                    },

                    cancelToken: new axios.CancelToken((c) =>{

                        cancelToken.current = c;

                    })

                }
            );

            setUploadedResponse(response.data)

            if(props.onFileUploaded)
                props.onFileUploaded(response.data);

        } catch (e) {


            cancelToken.current = undefined;
            setUploadPercentage();

            if(axios.isCancel(e)){
                console.log(e);

                return;
            }

            setUploadError(e)

            //TODO: Display some error
            console.log(e);

        } finally {
            setIsUploading(false);
        }

    }

    function cancelAndDelete(){

        if(props.onDeleteClicked)
            props.onDeleteClicked();

    }

    React.useEffect(
        ()=>{
            if(file)
                uploadFile()
        },[file]
    )

    return (
        <div>

            <div className={classes.root}>

                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}>

                    <div style={{
                        height: '100%',
                        width: `${uploadPercentage}%`,
                        borderRadius: 9
                    }}
                         className={clsx(
                             [
                                 'bg-white',
                                 {
                                     ['bg-light-danger']: uploadError && uploadError.response
                                 }
                             ]
                         )}
                    >

                    </div>

                </div>

                <div className={'row no-gutters'}>

                    <div className="col-auto">
                        <MimeTypeIcon type={file.type} />
                    </div>

                    <div className="col font-weight-bold small text-primary d-flex align-items-center">

                        <div style={{wordWrap: "break-word"}}>
                            {file.name.substr(0,35)}{file.name.length > 35 && '...'}
                        </div>

                        <div>
                            <ProgressBar animated now={uploadPercentage} />
                        </div>


                    </div>

                    <div className="col-auto">
                        <button disabled={props.disabled} onClick={cancelAndDelete} className="btn btn-icon btn-light-danger">
                            <i className={'flaticon2-delete'}></i>
                        </button>
                    </div>

                    {/*{*/}
                    {/*    uploadedResponse && (*/}
                    {/*        <div className="col-2">*/}
                    {/*            <span className="btn btn-icon btn-light-primary">*/}
                    {/*                <i className={'la la-search'}></i>*/}
                    {/*            </span>*/}
                    {/*        </div>*/}
                    {/*    )*/}
                    {/*}*/}


                </div>

            </div>

            {
                !isUploading && (
                    <label className={'d-block'}>

                        {
                            uploadError && uploadError.response && uploadError.response.status === 413 && (
                                <div className="small text-danger font-weight-bold">
                                    Fichier trop volumineux
                                </div>
                            )
                        }

                        {
                            uploadError && uploadError.response && uploadError.response.status === 422 && (
                                <div className="small text-danger font-weight-bold">
                                    Erreur lors de l'upload du fichier
                                </div>
                            )
                        }

                        {
                            uploadError && uploadError.response && uploadError.response.status === 500 && (
                                <div className="small text-danger font-weight-bold">
                                    Une erreur survenue est inconnue
                                </div>
                            )
                        }

                        {
                            uploadError && !uploadError.response && (
                                <div className="small text-danger font-weight-bold">
                                    Impossible d'envoyer le fichier, vérifier votre connexion à internet
                                </div>
                            )
                        }

                    </label>
                )
            }

            {/*{*/}
            {/*    isUploading && (*/}
            {/*        <div className={'d-flex align-items-center mt-3'}>*/}

            {/*            <div className={'flex-grow-1'}>*/}
            {/*                <ProgressBar animated now={uploadPercentage} />*/}
            {/*            </div>*/}

            {/*            <div onClick={cancelUpload} className={'btn btn-icon ml-2 btn-light-danger'}>*/}
            {/*                <i className={'flaticon2-delete'}></i>*/}
            {/*            </div>*/}

            {/*        </div>*/}
            {/*        )*/}
            {/*}*/}



        </div>
    );
}